module.exports = __webpack_public_path__ + "static/img/cost.4e2f58f8.png";